import { Link } from "react-router-dom";

import { PigMark } from "@/components/Logo";

const APP_SIGNUP_URL = (import.meta.env.VITE_APP_URL ?? "https://app.piggytrader.cc") + "/register";

export function Register() {
  return (
    <div className="mx-auto max-w-sm">
      <div className="rounded-2xl border border-line bg-surface p-7 text-center shadow-card">
        <div className="mx-auto grid h-12 w-12 place-items-center rounded-xl bg-brand-soft">
          <PigMark size={30} />
        </div>
        <h1 className="mt-3 text-xl font-extrabold tracking-tight text-ink">Create an account</h1>
        <p className="mt-2 text-ink-soft">
          Piggy accounts are created in the main app, then used to sign in here.
        </p>
        <a
          href={APP_SIGNUP_URL}
          className="mt-5 inline-block w-full rounded-lg bg-brand px-4 py-2.5 font-semibold text-white shadow-sm transition-colors hover:bg-brand-strong"
        >
          Create a Piggy account →
        </a>
      </div>
      <p className="mt-4 text-center text-sm text-ink-soft">
        Already have one?{" "}
        <Link to="/login" className="font-semibold text-brand-strong">
          Sign in
        </Link>
      </p>
    </div>
  );
}
